import { useCallback, useMemo } from 'react';

import { usePreferences } from '@/hooks/usePreferences';
import { preventClickThrough } from '@/util/util';

export function useAgentFavorites() {
  const { accountUserPrefs, updateAccountUserPreferences } = usePreferences();

  const favoriteIds = useMemo(
    () => (accountUserPrefs?.favorite_brain_ids as string[]) || [],
    [accountUserPrefs?.favorite_brain_ids]
  );

  const toggleFavorite = useCallback(
    (event: React.MouseEvent<HTMLElement>, aiAgentId: string) => {
      preventClickThrough(event);

      const isFavorite = favoriteIds.includes(aiAgentId);
      const newFavoriteIds = isFavorite
        ? favoriteIds.filter((id) => id !== aiAgentId)
        : [...favoriteIds, aiAgentId];

      updateAccountUserPreferences({
        ...(accountUserPrefs || {}),
        favorite_brain_ids: newFavoriteIds,
      });
    },
    [accountUserPrefs, updateAccountUserPreferences, favoriteIds]
  );

  return { favoriteIds, toggleFavorite };
}
